import { useEffect, useState } from "react";
import { Header } from "../components/site/Header";
import { Footer } from "../components/site/Footer";
import { PostCard } from "../components/site/PostCard";
import { WhatsAppFloat } from "../components/site/WhatsAppFloat";
import { Seo } from "../components/Seo";
import { fetchBlog } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    fetchBlog()
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]));
  }, []);

  const categories = posts
    ? ["All", ...new Set(posts.map((p) => p.category || "General"))]
    : ["All"];
  const visible = posts
    ? cat === "All"
      ? posts
      : posts.filter((p) => (p.category || "General") === cat)
    : [];

  return (
    <div className="min-h-screen bg-paper" data-testid="blog-page">
      <Seo
        title="BIDC Journal — Industrial Insights from Bhiwani"
        description="Policy explainers, market notes and construction updates from the BIDC industrial cluster, Bhiwani — published regularly by the site team."
        path="/blog"
        image="/assets/masterplan.webp"
      />
      <Header />
      <section className="relative bg-forest-dark grain">
        <div className="relative mx-auto max-w-7xl px-5 pb-16 pt-36 sm:px-8">
          <p className="text-xs sm:text-sm uppercase tracking-[0.3em] font-medium text-gold">BIDC Journal</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-medium tracking-tight text-paper">
            Notes from the estate
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-paper/70">
            Policy explainers, market notes and construction updates — straight from the Bhiwani
            site office.
          </p>
        </div>
      </section>

      <main className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        {posts === null ? (
          <div className="flex justify-center py-20">
            <Loader2 className="h-8 w-8 animate-spin text-gold" />
          </div>
        ) : posts.length === 0 ? (
          <p className="border border-dashed border-border bg-paper-light p-10 text-center text-sm text-[#4A4C4A]" data-testid="blog-empty">
            Articles are being prepared — check back soon.
          </p>
        ) : (
          <>
            {categories.length > 2 && (
              <div className="mb-8 flex flex-wrap gap-2" data-testid="blog-filters">
                {categories.map((c) => (
                  <button
                    key={c}
                    onClick={() => setCat(c)}
                    data-testid={`blog-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className={`border px-4 py-1.5 text-xs font-medium transition-colors duration-150 ${
                      cat === c
                        ? "border-forest bg-forest text-paper"
                        : "border-border bg-paper-light text-[#4A4C4A] hover:border-forest"
                    }`}
                  >
                    {c}
                  </button>
                ))}
              </div>
            )}
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="blog-grid">
              {visible.map((p) => (
                <PostCard key={p.id} post={p} />
              ))}
            </div>
          </>
        )}
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
